<template>
  <section>
    <div
      class="chart-box"
      ref="myChart"
      :style="{ height: boxHeight + 'rem' }"
    ></div>
  </section>
</template>

<script>
import * as echarts from "echarts";
export default {
  data() {
    return {};
  },
  props: {
    boxHeight: {
      default: 15,
      type: Number,
    },
    // colorList: {
    //   default: [],
    //   type: Array,
    // },
  },

  components: {},

  mounted() {
    // this.drawChart();
  },

  methods: {
    drawChart(data) {
      let _data = data;
      // console.log("饼状图传过来_data", _data);
      let _colorList = ["#5470c6", "#5200a4", "#ffae21", "#ee6666"];
      let myChart = echarts.init(this.$refs.myChart);
      let option = {
        // title: {
        //   text: "Nightingale Chart",
        //   subtext: "Fake Data",
        //   left: "center",
        // },
        color: _colorList,
        tooltip: {
          trigger: "item",
          backgroundColor: "rgba(0,0,0,0.3)",
          borderWidth: "0",
          textStyle: {
            color: "#fff",
            fontSize: this.$common.setFontSize(0.69),
          },
          // trigger: "item",
          formatter: "{b} : {c} ({d}%)",
        },
        // legend: {
        //   show: false,
        //   left: "center",
        //   top: "bottom",
        //   data: (() => {
        //     let arr = [];
        //     _data.map((obj, o_index) => {
        //       arr.push(obj.name);
        //     });
        //     return arr;
        //   })(),
        // },
        toolbox: {
          show: false,
          feature: {
            mark: { show: true },
            dataView: { show: true, readOnly: false },
            restore: { show: true },
            saveAsImage: { show: true },
          },
        },
        graphic: _data.showText
          ? [
              // {
              //   type: "text",
              //   left: "center",
              //   top: "40%",
              //   show:false,
              //   style: {
              //     text: _data.count,
              //     textAlign: "center",
              //     fill: "#FFF",
              //     shadowColor: "#5a91f6",
              //     shadowBlur:10,
              //     fontSize: this.$common.setFontSize(1),
              //   },
              // },
              {
                //环形图中间添加文字
                type: "text", //通过不同top值可以设置上下显示
                left: "center",
                top: "48%",
                style: {
                  text: "能源消费总量",
                  textAlign: "center",
                  fill: "#FFF", //文字的颜色
                  fontSize: this.$common.setFontSize(0.69),
                },
              },
              {
                type: "text",
                left: "center",
                top: "55%",
                style: {
                  text: "(万吨标准煤)",
                  textAlign: "center",
                  fill: "#FFF",
                  fontSize: this.$common.setFontSize(0.69),
                },
              },
            ]
          : [],
        series: [
          //   {
          //     name: "Radius Mode",
          //     type: "pie",
          //     radius: ['50%', '70%'],
          //     width:"50%",
          //     // center: ["25%", "50%"],
          //     label: {
          //       show: false,
          //     },
          //     emphasis: {
          //       label: {
          //         show: true,
          //       },
          //     },
          //     data: [
          //       { value: 40, name: "rose 1" },
          //       { value: 33, name: "rose 2" },
          //       { value: 28, name: "rose 3" },
          //       { value: 22, name: "rose 4" },
          //       { value: 20, name: "rose 5" },
          //       { value: 15, name: "rose 6" },
          //       { value: 12, name: "rose 7" },
          //       { value: 10, name: "rose 8" },
          //     ],
          //   },
          {
            // name: "Access From",
            type: "pie",
            radius: ["65%", "80%"],
            data: _data.data,
            label: {
              show: false,
              position: "inside",
              color: "#FFF",
              fontSize: this.$common.setFontSize(0.69),
            },

            //      {
            //     // name: "Access From",
            //     type: "pie",
            //     radius: ["60%", "80%"],
            //     data: _data,
            //     label: {
            //     normal: {
            //         // formatter: '{d}%, {c} \n\n',
            //         formatter: '{per|{d}%} , {c|{c}}\n{hr|}\n{a|}',//这里最后另一行设置了一个空数据是为了能让延长线与hr线对接起来
            //         // padding: [, -],//取消hr线跟延长线之间的间隙
            //         rich: {
            //             a: {
            //                 color: '#999',
            //                 // lineHeight: ,//设置最后一行空数据高度，为了能让延长线与hr线对接起来
            //                 align: 'center'
            //             },
            //             hr: {//设置hr是为了让中间线能够自适应长度
            //                 borderColor: 'auto',//hr的颜色为auto时候会主动显示颜色的
            //                 width: '105%',
            //                 borderWidth: 0.5,
            //                 height: 0.5,
            //             },
            //             per: {//用百分比数据来调整下数字位置，显的好看些。如果不设置，formatter最后一行的空数据就不需要
            //                 // padding: [, ],
            //             }
            //         }
            //     }
            // },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      };
      myChart.setOption(option);
    },
  },
};
</script>
<style lang='scss' scoped>
// .chart-box {
//   width: 50%;
// }
</style>